import { db, functions } from '@/plugins/firebase'
import axios from 'axios'

export default {
  async editQuiz (quizId, quiz) {
    const quizRef = await db.collection('quiz').doc(quizId)
    await quizRef.update(quiz)
    const quizData = (await quizRef.get()).data()
    quizData.id = quizRef.id
    return quizData
  }
}

export const sendMailAfterAssignLevelToQuiz = async (payload) => {
  try {
    console.log('Enviando correo después de asignar nivel al quiz con datos:', {
      ...payload,
      // Ocultando datos sensibles si existen
      password: payload.password ? '********' : undefined
    })

    // Adaptar el payload al formato que espera el backend
    // Backend espera: { student, classesAvailable, levelAssigned }
    const requestData = {
      student: {
        firstName: payload.fullName || '',
        email: payload.email,
        phone: payload.phone || ''
      },
      classesAvailable: payload.classesAvailable || [],
      levelAssigned: payload.userLevel
    }

    console.log('Payload transformado para API:', requestData)

    try {
      // Intentar primero con la función callable directamente
      console.log('Intentando con función callable...')
      try {
        // tslcSendLevelAssignedMail reemplaza a sendMailAfterAssignSuggestedLevel, que
        // responde 503 porque su SMTP de Gmail dejo de autenticar y su codigo fuente se
        // perdio. Misma firma de payload; la original sigue desplegada como respaldo.
        const callable = functions.httpsCallable('tslcSendLevelAssignedMail', {
          timeout: 20000
        })
        const result = await callable(requestData)
        console.log('Respuesta de función callable:', result.data)
        return result.data
      } catch (callableError) {
        console.warn('Error en función callable, intentando con HTTP:', callableError)
        // Si falla la función callable, intentar con HTTP
        const apiUrl = 'https://us-central1-admin-quiz-prod-ea152.cloudfunctions.net/sendMailAfterAssignSuggestedLevelHttp'

        console.log('Llamando a endpoint HTTP:', apiUrl)

        // Configuración mejorada para CORS
        const response = await axios.post(apiUrl, requestData, {
          // No establecer headers prohibidos como 'Origin';
          // el navegador y el SDK de Firebase gestionan CORS y App Check.
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: false
        })

        console.log('Respuesta de sendMailAfterAssignSuggestedLevelHttp:', response.data)

        if (!response.data || !response.data.success) {
          throw new Error(response.data?.error || 'Unknown server error')
        }

        return response.data
      }
    } catch (apiError) {
      console.error('Error en ambos métodos de envío de correo:', {
        name: apiError.name,
        message: apiError.message,
        response: apiError.response?.data,
        status: apiError.response?.status
      })

      // Antes se devolvia { success: true } aunque fallaran los dos metodos de envio, asi
      // que la UI mostraba "correo enviado" sin que saliera ningun correo. El nivel ya quedo
      // guardado en Firestore (paso previo, independiente); aqui solo reportamos que el
      // correo no salio para que quien lo asigna pueda avisar por otra via.
      throw apiError
    }
  } catch (error) {
    // Log richer error info for debugging
    const errInfo = {
      name: error && error.name,
      code: error && error.code,
      message: error && error.message,
      details: error && error.details
    }
    console.error('Error general en sendMailAfterAssignLevelToQuiz:', errInfo)
    throw error
  }
}
